import React from 'react';
import * as css from './WhatsAppImage.css';
import {useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next';
import EyeHideSection from '../../components/eyeHideSection/EyeHideSection';
import ConvertDecimalToHex from '../../../functions/ConvertDecimalToHex';
import ExternalImagePopup from '../../../component/imagePopup/externalImagePopup/ExternalImagePopup';
import ConditionalWrapper from '../../../component/conditionalWrapper/ConditionalWrapper';
import {isImagePathSupported, validateWhatsAppImage} from './whatsAppValidation';
import {useDefaultFbImage} from '../../../hooks/useDefaultFbImage';
import {getWhatsAppDefaultImagePath} from './getWhatsAppImagePath';

function WhatsAppImage({name = 'whatsappImage', eyeName = '', image, saveImage, imageXHR = null}) {
    const {t} = useTranslation('branding');
    const {currentLang} = useSelector(s => s.branding??{});
    const {colorMain} = useSelector(s => s.branding.data?.[currentLang]??{});
    const hexColor = colorMain && ConvertDecimalToHex(colorMain);
    const {type} = useSelector(s => s.event);

    const widthWindowWidth=useSelector(s=>s.ui.windowWidth);
    const imageHeight=Math.min(parseInt((widthWindowWidth-20)/3.94),200);
    const defaultFbImage = useDefaultFbImage(true);
    const hasUserImage = image?.path && isImagePathSupported(image.path);
    const fallbackImage = getWhatsAppDefaultImagePath(defaultFbImage, type);

    const imageEditorProps = {
        size: {width: Math.min(630,widthWindowWidth-90), height:imageHeight},
        image: hasUserImage ? image.path : undefined,
        imageId: image?.imageId,
        setImage: (image) => saveImage(image),
        type: 'image/jpeg,image/png',
        limitMB: 5,
        skipEditor: true, // Skip editor to avoid cropping - upload full image
        validateImage: (file) => validateWhatsAppImage(file, t)
    };
    const creditProps = {
        creditName: image?.creditName,
        alt: image?.alt,
        license: image?.license,
    };

    return (
        <css.wrapWhatsappImage>
            <css.wrapTitle>
                <css.whatsappImageTitle>{t('whatsappImage')}</css.whatsappImageTitle>
            </css.wrapTitle>
            <ConditionalWrapper
                condition={!!eyeName} wrapper={children => <EyeHideSection sectionName={eyeName}>{children}</EyeHideSection>}>
                <css.whatsappImage color={hexColor} height={`${imageHeight}px`} data-cy={`${name}Image`}>
                    {!hasUserImage && <css.image className={type} image={fallbackImage}/>}
                    <ExternalImagePopup imageProps={imageEditorProps} creditProps={creditProps} absoluteImage={!hasUserImage} imageXHR={imageXHR} />
                    <css.uploadIcon/>
                </css.whatsappImage>
            </ConditionalWrapper>
        </css.wrapWhatsappImage>
    );
}

export default WhatsAppImage;
